import "core-js/modules/es.function.name.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../src/assets/images/server.png';

_pushScopeId("data-v-0ae30f00");

var _hoisted_1 = {
  class: "dialog-info-wrapper"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "content-wrapper"
};

var _hoisted_4 = /*#__PURE__*/_createTextVNode("电话：");

var _hoisted_5 = /*#__PURE__*/_createTextVNode("地址：");

var _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "img--wrapper"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "wzyddxy"
})], -1);

var _hoisted_7 = /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "有问题请与客服沟通", -1);

var _hoisted_8 = /*#__PURE__*/_createTextVNode(" 关闭 ");

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_button = _resolveComponent("van-button");

  var _component_van_overlay = _resolveComponent("van-overlay");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_overlay, {
    show: $props.show,
    "z-index": "3"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_1, [_createElementVNode("p", _hoisted_2, _toDisplayString($options.titleInfo), 1), _createElementVNode("div", _hoisted_3, [_createElementVNode("p", null, "姓名：" + _toDisplayString($props.item.name), 1), _createElementVNode("p", null, [_hoisted_4, _createElementVNode("span", null, _toDisplayString($props.item.mobile), 1)]), _createElementVNode("p", null, [_hoisted_5, _createElementVNode("span", null, _toDisplayString($props.item.addr || "暂无"), 1)])]), _hoisted_6, _hoisted_7, _createElementVNode("p", {
        class: "tip",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return $options.onClickCopy('wzyddxy');
        })
      }, _toDisplayString($data.tip), 1), _createVNode(_component_van_button, {
        onClick: $options.onClickClose,
        plain: "",
        round: "",
        size: "normal",
        type: "primary",
        color: "#B6B6B6"
      }, {
        default: _withCtx(function () {
          return [_hoisted_8];
        }),
        _: 1
      }, 8, ["onClick"])])];
    }),
    _: 1
  }, 8, ["show"])]);
}